import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a840e03c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a840e03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a840e03c')) {
      api.createRecord('a840e03c', component.options)
    } else {
      api.reload('a840e03c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a840e03c&scoped=true&", function () {
      api.rerender('a840e03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JTVJsAeTZvJP/JS/comp/Accordion.vue"
export default component.exports